const fwdActionStrings = {
    en: "Set your clock forward %HOURS%.",
    es: "O relógio adianta %HOURS%.",
    pt: "Adiante o relógio em %HOURS%.",
    fr: "Avancez votre horloge de %HOURS%.",
    it: "Spostate le lancette in avanti di %HOURS%.",
    de: "Bitte stellen sie ihre Uhren um %HOURS% vor.",
    pl: "Wskazania zegarów przesunęliśmy %HOURS% do przodu.",
    uk: "Переведіть годинник на %HOURS% вперед.",
    ru: "Переведите часы на %HOURS% вперед.",
    zh: "将时钟向前调%HOURS%。",
    ja: "時計を%HOURS%進めます。",
    nl: "Zet uw klokken %HOURS% vooruit.",
    da: "Indstil dit ur %HOURS% frem.",
}

const bwdActionStrings = {
    en: "Set your clock backward %HOURS%.",
    es: "O relógio atrasa %HOURS%.",
    pt: "Atrasa o relógio em %HOURS%.",
    fr: "Retardez votre horloge de %HOURS%.",
    it: "Imposta l'orologio in avanti di %HOURS%.",
    de: "Bitte stellen sie ihre Uhren um %HOURS% zurück.",
    pl: "Cofnięcia o %HOURS% wskazań zegarów.",
    uk: "Переведіть годинник на %HOURS% назад.",
    ru: "Переведите часы на %HOURS% назад.",
    zh: "将时钟调回%HOURS%。",
    ja: "時計を%HOURS%戻します。",
    nl: "Zet uw klokken %HOURS% terug.",
    da: "Sæt dit ur %HOURS% timer tilbage.",
}

const lastChangeTodayStrings = {
    en: "Last time change was today, %DATE_STRING%.",
    es: "Ultima mudança horária fue hoy %DATE_STRING%.",
    pt: "Ultima mudança horária foi hoje %DATE_STRING%.",
    fr: "Dernier changement d’heure aujourd’hui %DATE_STRING%.",
    it: "L’ultimo cambio d'ora e succeso oggi %DATE_STRING%.",
    de: "Die Uhrzeit ändert sich war heute %DATE_STRING%.",
    pl: "Ostatnia zmiana czasu była dzisiaj %DATE_STRING%.",
    uk: "Остання зміна часу була сьогодні %DATE_STRING%.",
    ru: "Последний перевод часов был сегодня %DATE_STRING%.",
    zh: "上次更改是今天%DATE_STRING%。",
    ja: "前回の変更は今日でした %DATE_STRING%",
    nl: "Klok verzetten vandaag %DATE_STRING%.",
    da: "Sidste ændring var i dag %DATE_STRING%.",
};

const lastChangeStrings = {
    en: "Last time change was %TIME_DIFF_STRING% ago, %DATE_STRING%.",
    es: "Ultima mudança horária fue hace %TIME_DIFF_STRING% %DATE_STRING%.",
    pt: "Ultima mudança horária foi ha %TIME_DIFF_STRING% %DATE_STRING%.",
    fr: "Prochain changement d’heure dans %TIME_DIFF_STRING% %DATE_STRING%.",
    it: "L’ultimo cambio d'ora e succeso %TIME_DIFF_STRING% fa %DATE_STRING%.",
    de: "Die Uhrzeit ändert sich war vor %TIME_DIFF_STRING% %DATE_STRING%.",
    pl: "Ostatnia zmiana nastąpiła %TIME_DIFF_STRING% temu %DATE_STRING%.",
    uk: "Остання зміна часу була %TIME_DIFF_STRING% тому %DATE_STRING%.",
    ru: "Последний перевод часов был %TIME_DIFF_STRING% назад в %DATE_STRING%.",
    zh: "上次更改是%TIME_DIFF_STRING%前%DATE_STRING%.",
    ja: "前回の変更は%TIME_DIFF_STRING%%DATE_STRING%",
    nl: "Klok verzetten was %TIME_DIFF_STRING% geleden %DATE_STRING%.",
    da: "Sidste ændring var for %TIME_DIFF_STRING% siden %DATE_STRING%.",
};

const nextChangeTodayStrings = {
    en: "Next time change is today %DATE_STRING%.",
    es: "Próxima mudança horária hoy %DATE_STRING%.",
    pt: "Próxima mudança horária hoje %DATE_STRING%.",
    fr: "Prochain changement d’heure aujourd’hui %DATE_STRING%.",
    it: "Prossimo cambio d'ora succede oggi %DATE_STRING%.",
    de: "Die Uhrzeit ändert sich heute %DATE_STRING%.",
    pl: "Następna zmiana czasu nastąpi dzisiaj %DATE_STRING%.",
    uk: "Наступна зміна часу сьогодні %DATE_STRING%.",
    ru: "Следующий перевод часов сегодня %DATE_STRING%.",
    zh: "下次是今天%DATE_STRING%.",
    ja: "次回の変更は今日です%DATE_STRING%",
    nl: "Klok verzetten vandaag %DATE_STRING%.",
    da: "Næste gang skift i dag %DATE_STRING%.",
};

const nextChangeStrings = {
    en: "Next time change is in %TIME_DIFF_STRING% %DATE_STRING%.",
    es: "Próxima mudança horária em %TIME_DIFF_STRING% %DATE_STRING%.",
    pt: "Próxima mudança horária em %TIME_DIFF_STRING% %DATE_STRING%.",
    fr: "Prochain changement d’heure dans %TIME_DIFF_STRING% %DATE_STRING%.",
    it: "Prossimo cambio d'ora tra %TIME_DIFF_STRING% %DATE_STRING%.",
    de: "Die Uhrzeit ändert sich in %TIME_DIFF_STRING% %DATE_STRING%.",
    pl: "Next time change in %TIME_DIFF_STRING% %DATE_STRING%.",
    uk: "Наступна зміна часу за %TIME_DIFF_STRING% %DATE_STRING%.",
    ru: "Следующий перевод часов через %TIME_DIFF_STRING% %DATE_STRING%.",
    zh: "下次更改是在%TIME_DIFF_STRING%%DATE_STRING%.",
    ja: "次回の変更は%TIME_DIFF_STRING%%DATE_STRING%",
    nl: "Klok verzetten over %TIME_DIFF_STRING% %DATE_STRING%.",
    da: "Næste gang ændres i %TIME_DIFF_STRING% %DATE_STRING%.",
};

const hourStrings = {
    en: "hour",
    es: "hora",
    pt: "hora",
    fr: "heure",
    it: "ora",
    de: "Stunde",
    pl: "godzinę",
    uk: "годину",
    ru: "час",
    zh: "小时",
    ja: "時間",
    nl: "uur",
    da: "time",
}

const hourStringsPlural = {
    en: "hours",
    es: "horas",
    pt: "horas",
    fr: "heures",
    it: "ore",
    de: "Stunden",
    pl: "godziny",
    uk: "години",
    ru: "часа",
    zh: "小时",
    ja: "時間",
    nl: "uur",
    da: "timer",
}

const diffStrings = {
    en: "%MONTHS_STRING% and %DAYS_STRING%",
    es: "%MONTHS_STRING% y %DAYS_STRING%",
    pt: "%MONTHS_STRING% e %DAYS_STRING%",
    fr: "%MONTHS_STRING% et %DAYS_STRING%",
    it: "%MONTHS_STRING% e %DAYS_STRING%",
    de: "%MONTHS_STRING% und %DAYS_STRING%",
    pl: "%MONTHS_STRING% i %DAYS_STRING%",
    uk: "%MONTHS_STRING% i %DAYS_STRING%",
    ru: "%MONTHS_STRING% и %DAYS_STRING%",
    zh: "%MONTHS_STRING% 和 %DAYS_STRING%",
    ja: "%MONTHS_STRING% と %DAYS_STRING%",
    nl: "%MONTHS_STRING% en %DAYS_STRING%",
    da: "%MONTHS_STRING% og %DAYS_STRING%",
}

const dayStrings = {
    en: "%DAYS% day",
    es: "%DAYS% dia",
    pt: "%DAYS% dia",
    fr: "%DAYS% jour",
    it: "%DAYS% giorno",
    de: "%DAYS% Tag",
    pl: "%DAYS% dzień",
    uk: "%DAYS% день",
    ru: "%DAYS% день",
    zh: "%DAYS% 天",
    ja: "%DAYS% 日",
    nl: "%DAYS% dag",
    da: "%DAYS% dag",
}

const dayStringsPlural = {
    en: "%DAYS% days",
    es: "%DAYS% dias",
    pt: "%DAYS% dias",
    fr: "%DAYS% jours",
    it: "%DAYS% giorni",
    de: "%DAYS% Tage",
    pl: "%DAYS% dni",
    uk: "%DAYS% дні",
    ru: "%DAYS% дня",
    zh: "%DAYS% 天",
    ja: "%DAYS% 日",
    nl: "%DAYS% dagen",
    da: "%DAYS% dage",
}

const monthStrings = {
    en: "%MONTHS% month",
    es: "%MONTHS% mes",
    pt: "%MONTHS% mês",
    fr: "%MONTHS% mois",
    it: "%MONTHS% mese",
    de: "%MONTHS% Monat",
    pl: "%MONTHS% miesiąc",
    uk: "%MONTHS% місяць",
    ru: "%MONTHS% месяц",
    zh: "%MONTHS% 个月零",
    ja: "%MONTHS% ヶ月",
    nl: "%MONTHS% maand",
    da: "%MONTHS% måned",
}

const monthStringsPlural = {
    en: "%MONTHS% months",
    es: "%MONTHS% meses",
    pt: "%MONTHS% meses",
    fr: "%MONTHS% mois",
    it: "%MONTHS% mesi",
    de: "%MONTHS% Monate",
    pl: "%MONTHS% miesiące",
    uk: "%MONTHS% місяці",
    ru: "%MONTHS% месяца",
    zh: "%MONTHS% 个月零",
    ja: "%MONTHS% ヶ月",
    nl: "%MONTHS% maanden",
    da: "%MONTHS% måneder",
}

function loadHeaderClock(responseData) {
    if (responseData["tr"]["has_transitions"]) {
        const transitionMessage = getClosestTransitionHint(responseData["tz"], responseData["tr"], tickerVars.lang);

        if (transitionMessage) {
            document.getElementById("header-clock-location").innerHTML = responseData["loc"];
            document.getElementById("header-clock-message").innerHTML = transitionMessage;
            document.getElementById("header-clock").style.display = "block";

            addScriptTag('/js/clock/index_clock.min.js', false, true);
        }
    }
}

function getGeoData() {
    let url = window.location.protocol + "//" + window.location.host + "/me";

    if (tickerVars.lang !== "en") {
        url += "?lang=" + tickerVars.lang;
    }

    const request = new XMLHttpRequest();
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            const responseData = JSON.parse(request.responseText);

            if (responseData !== null) {
                tickerVars.server_time = responseData["ts"];
                tickerVars.transitions = responseData["tr"];

                loadHeaderClock(responseData);
            }
        }
    };
    request.open("GET", url, true);
    request.send(null);
}

getGeoData();

function getClosestTransitionHint(ianaTimezone, transitionData) {
    let resultString = "";
    const localCurrentTime = moment.unix(tickerVars.server_time).tz(ianaTimezone);
    const nextTransitionData = getNextTransitionData(ianaTimezone, transitionData);
    const lastTransitionData = getLastTransitionData(ianaTimezone, transitionData);

    const nextTransitionTime = nextTransitionData.nextTransition;
    const lastTransitionTime = lastTransitionData.lastTransition;
    const nextAction = nextTransitionData.actionType;
    const lastAction = lastTransitionData.actionType;
    let useNextTransition = true;

    if (lastTransitionTime) {
        const timeFromLast = localCurrentTime.unix() - lastTransitionTime;
        if (timeFromLast < 3600 * 24 * 14) {
            useNextTransition = false;
            resultString = getTimeChangeString(lastTransitionTime, ianaTimezone, lastAction, !useNextTransition);
        }
    }

    if (useNextTransition) {
        if (nextTransitionTime) {
            const timeTillNext = nextTransitionTime - localCurrentTime.unix();
            if (timeTillNext < 3600 * 24 * 14) {
                resultString = getTimeChangeString(nextTransitionTime, ianaTimezone, nextAction, !useNextTransition);
            }
        }
    }

    return resultString;
}

function getTimeChangeString(transitionTime, ianaTimezone, action, last = true) {
    const transition = moment.unix(transitionTime).tz(ianaTimezone);
    const localCurrentTime = moment.unix(tickerVars.server_time).tz(ianaTimezone);
    const dateString = "<span class=\"cls-transition-date\">" + transition.format("LLLL") + "</span>";

    const daysDiff = Math.abs(localCurrentTime.diff(transition, "days"));
    const monthsDiff = Math.abs(localCurrentTime.diff(transition, "months"));
    let timeDiffString = getTimeDiffString(daysDiff, monthsDiff);
    let transitionToday = false;

    if (!timeDiffString) {
        if (localCurrentTime.format("M/D") === transition.format("M/D")) {
            transitionToday = true;
        } else {
            timeDiffString = getDaysString(1);
        }
    }

    if (last) {
        return getLocalizedLastChange(dateString, timeDiffString, transitionToday) + " " + getClockActionString(action);
    } else {
        return getLocalizedNextChange(dateString, timeDiffString, transitionToday) + " " + getClockActionString(action);
    }
}

function getClockActionString(action) {
    const offsetDiff = Math.abs((tickerVars.transitions["raw_offset"] - tickerVars.transitions["dst_offset"]) / 3600);
    const hourString = offsetDiff + " " + getHoursString(offsetDiff);

    let clockActionString = action > 0 ? fwdActionStrings[tickerVars.lang] : bwdActionStrings[tickerVars.lang];
    clockActionString = clockActionString.replace("%HOURS%", hourString);

    return clockActionString;
}

function getLocalizedLastChange(dateString, timeDiffString, today) {
    if (today) {
        return lastChangeTodayStrings[tickerVars.lang].replace("%DATE_STRING%", dateString);
    } else {
        return lastChangeStrings[tickerVars.lang]
            .replace("%DATE_STRING%", dateString)
            .replace("%TIME_DIFF_STRING%", timeDiffString);
    }
}

function getLocalizedNextChange(dateString, timeDiffString, today) {
    if (today) {
        return nextChangeTodayStrings[tickerVars.lang].replace("%DATE_STRING%", dateString);
    } else {
        return nextChangeStrings[tickerVars.lang]
            .replace("%DATE_STRING%", dateString)
            .replace("%TIME_DIFF_STRING%", timeDiffString);
    }
}

function getTimeDiffString(daysDiff, monthsDiff) {
    let timeDiffString;

    if (monthsDiff > 0 && daysDiff > 0) {
        daysDiff = daysDiff % 30;
        const daysString = getDaysString(daysDiff);
        const monthsString = getMonthsString(monthsDiff);
        timeDiffString = getCombinedTimeDiffString(daysString, monthsString);
    } else if (daysDiff > 0) {
        timeDiffString = getDaysString(daysDiff);
    } else if (monthsDiff > 0) {
        timeDiffString = getDaysString(monthsDiff);
    }


    return timeDiffString;
}

function getCombinedTimeDiffString(daysString, monthsString) {
    return diffStrings[tickerVars.lang]
        .replace("%MONTHS_STRING%", monthsString)
        .replace("%DAYS_STRING%", daysString);
}

function getHoursString(hours) {
    return hours > 1 ? hourStringsPlural[tickerVars.lang] : hourStrings[tickerVars.lang];
}

function getDaysString(days) {
    const daysString = days > 1 ? dayStringsPlural[tickerVars.lang] : dayStrings[tickerVars.lang];
    return daysString.replace("%DAYS%", days);
}

function getMonthsString(months) {
    const monthString = months === 1 ? monthStrings[tickerVars.lang] : monthStringsPlural[tickerVars.lang];
    return monthString.replace("%MONTHS%", months);
}

function getNextTransitionData(ianaTimezone, transitionData) {
    let nextTransition, actionType = null;

    if (transitionData["has_transitions"]) {
        const localCurrentTime = moment.unix(tickerVars["server_time"]).tz(ianaTimezone).unix();
        const dstStarts = moment.unix(transitionData["dst_starts"]).tz(ianaTimezone).unix();
        const dstEnds = moment.unix(transitionData["dst_ends"]).tz(ianaTimezone).unix();

        if (dstStarts && dstEnds) {
            if (dstStarts < dstEnds) {
                if (localCurrentTime <= dstStarts) {
                    nextTransition = dstStarts;
                    actionType = 1;
                } else if (dstStarts < localCurrentTime && localCurrentTime < dstEnds) {
                    nextTransition = dstEnds;
                    actionType = -1;
                }
            } else {
                if (localCurrentTime < dstEnds) {
                    nextTransition = dstEnds;
                    actionType = -1;
                } else if (dstEnds <= localCurrentTime && localCurrentTime < dstStarts) {
                    nextTransition = dstStarts;
                    actionType = 1;
                }
            }
        } else if (dstStarts) {
            if (localCurrentTime < dstStarts) {
                nextTransition = dstStarts;
                actionType = 1;
            }
        } else if (dstEnds) {
            if (localCurrentTime < dstEnds) {
                nextTransition = dstEnds;
                actionType = -1;
            }
        }
    }

    return {"nextTransition": nextTransition, "actionType": actionType};
}

function getLastTransitionData(ianaTimezone, transitionData) {
    let lastTransition, actionType = null;

    if (transitionData["has_transitions"]) {
        const localCurrentTime = moment.unix(tickerVars["server_time"]).tz(ianaTimezone).unix();
        const dstStarts = moment.unix(transitionData["dst_starts"]).tz(ianaTimezone).unix();
        const dstEnds = moment.unix(transitionData["dst_ends"]).tz(ianaTimezone).unix();

        if (dstStarts && dstEnds) {
            if (dstStarts < dstEnds) {
                if (dstStarts <= localCurrentTime && localCurrentTime < dstEnds) {
                    lastTransition = dstStarts;
                    actionType = 1;
                } else if (dstEnds <= localCurrentTime) {
                    lastTransition = dstEnds;
                    actionType = -1;
                }
            } else {
                if (dstEnds <= localCurrentTime && localCurrentTime < dstStarts) {
                    lastTransition = dstEnds;
                    actionType = -1;
                } else if (dstStarts <= localCurrentTime) {
                    lastTransition = dstStarts;
                    actionType = 1;
                }
            }
        } else if (dstStarts) {
            if (dstStarts < localCurrentTime) {
                lastTransition = dstStarts;
                actionType = 1;
            }
        } else if (dstEnds) {
            if (dstEnds < localCurrentTime) {
                lastTransition = dstEnds;
                actionType = -1;
            }
        }
    }

    return {"lastTransition": lastTransition, "actionType": actionType};
}
